import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Link } from 'react-router-dom';
import './Home.css';

const LockGlyph = () => (
  <svg
    aria-hidden="true"
    width="26"
    height="26"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

const Home = () => {
  const { user, isAuthenticated } = useAuth();

  return (
    <section className="home-wrapper">
      <div className="home-card">
        <div className="home-label">
          <span className="home-icon" aria-hidden="true">
            <LockGlyph />
          </span>
          <span className="home-badge">Customeeze · 3D Crystal Engraving</span>
        </div>
        <h1 className="home-title">
          {isAuthenticated
            ? `Welcome back, ${user?.username ?? 'creator'}!`
            : 'Turn photos into 3D crystal keepsakes'}
        </h1>
        <p className="home-description">
          {isAuthenticated
            ? 'Jump into your dashboard to review recent activity, process new images, and manage the experiences your customers depend on.'
            : 'Customeeze converts customer photos into ready-to-engrave 3D crystal models, with guided image preparation and preview tools built for engraving workflows.'}
        </p>

        <div className="home-actions">
          {isAuthenticated ? (
            <>
              <Link to="/image-tools" className="btn-primary home-cta">
                Choose image workflow
              </Link>
              <Link to="/dashboard" className="btn-secondary">
                View Dashboard
              </Link>
            </>
          ) : (
            <>
              <Link to="/login" className="btn-primary home-cta">
                Start your 3D conversion
              </Link>
              <Link to="/login" className="btn-secondary">
                Log in or create account
              </Link>
            </>
          )}
        </div>

        {!isAuthenticated && (
          <p className="home-footnote">
            You&apos;ll be asked to log in or create a new account before uploading images for engraving.
          </p>
        )}
      </div>
    </section>
  );
};

export default Home;
